import React from "react";
import uuid from "uuid";
// import axios from "axios";
// import moment from "moment";
import "date-fns";

import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from "@material-ui/pickers";

const useStyles = makeStyles(theme => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3)
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200
  }
}));

export default function AddModal(props) {
  const classes = useStyles();
  const { open, setOpen, newDataHandler } = props;
  const [title, setTitle] = React.useState("");
  const [body, setBody] = React.useState("");
  const [deadline, setDeadline] = React.useState(new Date());

  const handleNameChange = event => {
    setTitle(event.target.value);
    // console.log(title);
  };

  const handleDescriptionChange = event => {
    setBody(event.target.value);
    // console.log(body);
  };

  const handleDateChange = date => {
    setDeadline(date);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const afterSubmit = data => {
    // const test = new Date(data.deadline);
    // const a = parseInt(moment(data.deadline).format("DD"));
    // console.log(a + 5);
    // if (data.success) {
    handleClose();
    newDataHandler(data);
    setTitle("");
    setBody("");
    // console.log(data);
    // } else {
    // }
  };

  const submitForm = event => {
    event.preventDefault();
    if (title === undefined || body === undefined || deadline === undefined) {
      console.log(`All fields required`);
    } else {
      // console.log(deadline);
      const data = {
        _id: uuid.v4(),
        title,
        body,
        deadline,
        hidden: false,
        date: new Date(),
        status: "todo"
      };
      afterSubmit(data);
      // axios
      //   .post("http://localhost:5000/add", data)
      //   .then(data => afterSubmit(data.data))
      //   .catch(err => console.log(err));
    }
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <Typography align="center" variant="h4" className={classes.title}>
              Add Todo
            </Typography>{" "}
            <form className={classes.container} noValidate autoComplete="off">
              <Grid container spacing={3}>
                <Grid item xs>
                  <TextField
                    required
                    id="standard-name"
                    label="Title"
                    placeholder="Add title"
                    defaultValue={title}
                    onChange={handleNameChange}
                    className={classes.textField}
                    margin="normal"
                    autoFocus={true}
                  />
                </Grid>
                <Grid item xs>
                  <TextField
                    required
                    id="standard-required"
                    label="Description"
                    placeholder="Add Description"
                    defaultValue={body}
                    onChange={handleDescriptionChange}
                    className={classes.textField}
                    margin="normal"
                  />
                </Grid>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <Grid item xs>
                    <KeyboardDatePicker
                      disableToolbar
                      variant="inline"
                      format="MM/dd/yyyy"
                      margin="normal"
                      id="date-picker-inline"
                      label="Deadline"
                      value={deadline}
                      onChange={handleDateChange}
                      KeyboardButtonProps={{
                        "aria-label": "change date"
                      }}
                    />
                  </Grid>
                </MuiPickersUtilsProvider>

                <Grid item xs>
                  <Button onClick={submitForm} color="primary">
                    Submit
                  </Button>
                </Grid>
              </Grid>
            </form>
          </div>
        </Fade>
      </Modal>
    </div>
  );
}
